/* eslint-disable no-shadow */
import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import SSOLink from "@COMPONENTS/common/ssoLink";
import {TDetailPackage} from "@COMPONENTS/product/types";
import * as style from "@COMPONENTS/style/detailpackage/promotionproductM";
import SlideImage from "@FRAMEWORK/ui/mobile/slide/SlideImage";
import useRcmnOfSimList from "@QUERIES/chorus/rcmn/useRcmnOfSimList";
import {format} from "@yb/utils";
import dayjs from "dayjs";
import {memo} from "react";

const DetailRecommendProductComponent = (props: TDetailPackage) => {
	const {
		query: {evCd},
	} = props;
	/** 추천상품 조회 */
	const rcmnOfSimListFetch = useRcmnOfSimList(evCd, {
		placeholderData: {crmRcmnSearchSimResultList: [], errorCode: "", errorMsg: ""},
	});
	const recommendList = rcmnOfSimListFetch.data.crmRcmnSearchSimResultList || [];

	return (
		<>
			{recommendList.length > 0 && (
				<style.Wrap>
					<style.SubTitle>추천 상품</style.SubTitle>
					<style.SliderWrap>
						<style.Slider slidesPerView={"auto"}>
							{recommendList
								.slice(0, 10) // 최대 10개만 노출
								.map((recommend, index) => {
									const {outStartDt, adtPrice, landing, imageThum1, evNm} = recommend;
									return (
										<style.SwiperSlideWrap key={index}>
											<SSOLink href={landing} target="_blank">
												<style.ImageBox>
													<SlideImage src={imageThum1} alt="프로모션 이미지" width={225} height={150} />
												</style.ImageBox>
												<style.InfoBox>
													<style.SlideTitle>{evNm}</style.SlideTitle>
													<style.Date>
														<em>출발일</em> {dayjs(outStartDt).format("YYYY.MM.DD")}
													</style.Date>
													<style.InfoBottomBlock>
														<style.Price>
															<strong>{format.koKRFormatNumber(adtPrice)}</strong>원
														</style.Price>
													</style.InfoBottomBlock>
												</style.InfoBox>
											</SSOLink>
										</style.SwiperSlideWrap>
									);
								})}
						</style.Slider>
					</style.SliderWrap>
				</style.Wrap>
			)}
		</>
	);
};

const DetailRecommendProduct = (props: TDetailPackage) => (
	<ErrorBoundary logMsg="EventDetailRecommendProduct Error">
		<DetailRecommendProductComponent {...props} />
	</ErrorBoundary>
);

export default memo(DetailRecommendProduct);
